import AbstractManageable   from './abstract-manageable';
import Instruction          from './instruction';
import User                 from './user';
import OperationType        from './operation-type';

export default class Chapter extends AbstractManageable {
	/**
	 * @param {Number}          id 
	 * @param {String}          number 
	 * @param {String}          label
	 * @param {OperationType[]} types
	 * @param {Instruction}     instruction
	 * @param {User}            creator 
	 * @param {Date}            createdAt 
	 * @param {User}            updater 
	 * @param {Date}            updatedAt 
	 */
	constructor(
			id,
			number,
			label,
			types,
			instruction,
			creator,
			createdAt,
			updater,
			updatedAt) {
		super(creator, createdAt, updater, updatedAt);
		this.id          = id;
		this.number      = number;
		this.label       = label;
		this.types       = types;
		this.instruction = instruction;
		this.creator     = creator;
		this.createdAt   = createdAt;
		this.updater     = updater;
		this.updatedAt   = updatedAt;
	}

	static createFromJson = (json) => {
		if (!json) return null;

		const id          = json.id;
		const number      = json.number;
		const label       = json.label;
		const types       = OperationType.createFromJson(json.types)
		const instruction = Instruction.createFromJson(json.instruction);
		const creator     = User.createFromJson(json.creator);
		const createdAt   = new Date(json.createdAt);
		const updater     = User.createFromJson(json.updater);
		const updatedAt   = new Date(json.updatedAt);

		return new Chapter(
			id,
			number,
			label,
			types,
			instruction,
			creator,
			createdAt,
			updater,
			updatedAt);
	}
}


// WEBPACK FOOTER //
// ./src/model/chapter.js